/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, serializeUpdateProductPricesRequest, type ErrorResponse, type InternalErrorResponse, type UpdateProductPricesRequest } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/products/prices
 */
export interface PricesRequestBuilder extends BaseRequestBuilder<PricesRequestBuilder> {
    /**
     * Updates the price tiers for multiple products in a single request, matched on SKU. This endpoint allows you to create or update multiple price tiers for multiple products efficiently. For an agency organization a row's vendorCode names the line the product belongs to and the row's SKU is matched as {vendorCode}-{sku}, the way the product import stores it, a value already carrying the prefix being left alone, so an exported sheet re-imports unchanged; every vendorCode must be one of the organization's vendors, and the whole batch is refused before any write otherwise. A row without a vendorCode uses its SKU exactly as given.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     put(body: UpdateProductPricesRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * Updates the price tiers for multiple products in a single request, matched on SKU. This endpoint allows you to create or update multiple price tiers for multiple products efficiently. For an agency organization a row's vendorCode names the line the product belongs to and the row's SKU is matched as {vendorCode}-{sku}, the way the product import stores it, a value already carrying the prefix being left alone, so an exported sheet re-imports unchanged; every vendorCode must be one of the organization's vendors, and the whole batch is refused before any write otherwise. A row without a vendorCode uses its SKU exactly as given.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: UpdateProductPricesRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const PricesRequestBuilderUriTemplate = "{+baseurl}/api/products/prices";
/**
 * Metadata for all the requests in the request builder.
 */
export const PricesRequestBuilderRequestsMetadata: RequestsMetadata = {
    put: {
        uriTemplate: PricesRequestBuilderUriTemplate,
        responseBodyContentType: "application/problem+json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeUpdateProductPricesRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
